export function traversalMenu (arr) {
  function traverse (node) {
    if (!node) {
      return
    }
    set.add(node.url)
    power[node.url] = {}
    if (node.operateResources && node.operateResources.length > 0) {
      node.operateResources.forEach(item => {
        power[node.url][item.code] = item.name
      })
    }
    if (node.childMenu && node.childMenu.length > 0) {
      let i = 0
      for (i = 0; i < node.childMenu.length; i++) {
        traverse(node.childMenu[i])
      }
    }
  }
  const set = new Set()
  const power = {}
  arr.forEach(item => {
    traverse(item)
    set.add(item.url)
  })
  set.delete(null)
  set.delete('')
  return {
    url: [...set],
    power
  }
}

// 获取地址栏的参数
export function getUrl (params) {
  var after = window.location.href.split('?')[1]
  if (after) {
    var reg = new RegExp('(^|&)' + params + '=([^&]*)(&|$)')
    var r = after.match(reg)
    if (r) {
      return decodeURIComponent(r[2])
    } else {
      return null
    }
  }
}

// 下载blob文件
export function downloadBlob (data, name) {
  const a = document.createElement('a')
  window.console.log(a)
}
